<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.editEmployerHoursBanks_title + " " + form.controls.defaultName.value | uppercase}}
  </h6>

  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="section-container">
      <div class="title-container">
        <h2 class="overline grey1 semibold section-title">{{ data.sysText.editEmployerHoursBanks_bankSettings }}</h2>
        <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
        <button
          type="button"
          class="button-reset info-button"
          [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
          [matTooltip]="data.sysText.employerHoursBanks_nameInfo"
          [matTooltipShowDelay]="500"
          matTooltipPosition="before">
          <mat-icon class="button-icon">info_outline</mat-icon>
        </button>
      </div>
      <mat-divider class="section-header-underline"></mat-divider>
      <div class="field">
        <app-input-field
          [hideIconSpace]="false"
          [label]="data.sysText.employerHoursBanks_primaryName"
          [icon]="'label_important'"
          [control]="form.controls.primaryName">
        </app-input-field>
      </div>
      @if (data.isBank) {
        <div class="slide-container">
          <app-slide-toggle
            [control]="form.controls.isProtected"
            [icon]="'lock'"
            [label]="data.sysText.editEmployerHoursBanks_isProtected">
          </app-slide-toggle>
          <button
            type="button"
            class="button-reset info-button"
            [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
            [matTooltip]="data.sysText.employerHoursBanks_isProtectedInfo"
            [matTooltipShowDelay]="500"
            matTooltipPosition="right">
            <mat-icon class="button-icon">info_outline</mat-icon>
          </button>
        </div>
        <div class="slide-container">
          <app-slide-toggle
            [control]="form.controls.primaryFullDayIncrements"
            [capitalizeLabel]="false"
            [icon]="'today'"
            [label]="data.sysText.employerHoursBanks_fullDayIncrements">
          </app-slide-toggle>
          <button
            type="button"
            class="button-reset info-button"
            [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
            [matTooltip]="data.sysText.employerHoursBanks_fullDayIncrementsInfo"
            [matTooltipShowDelay]="500"
            matTooltipPosition="right">
            <mat-icon class="button-icon">info_outline</mat-icon>
          </button>
        </div>
      }
      <div>
        @for(stateFormGroup of form.controls.stateSpecificBankNames.controls; track stateFormGroup; let stateIndex = $index){
          <div class="field-row-container state-name">
            <div class="field-container">
              <div class="field-line">
                <app-select-field
                  class="margin-right"
                  [group]="form"
                  [icon]="'label'"
                  [control]="stateFormGroup.controls.stateId"
                  [options]="stateSelectionOptions[stateIndex]"
                  [label]="data.sysText.employerHoursBanks_state"
                  [shouldCapitalize]="false">
                </app-select-field>
                <div class="field">
                  <app-input-field
                    [label]="data.sysText.employerHoursBanks_stateName"
                    [hideIconSpace]="!(isHandheld$ | async)"
                    [control]="stateFormGroup.controls.stateSpecificName">
                  </app-input-field>
                </div>
              </div>
              @if (data.isBank) {
                <div class="slide-container">
                  <app-slide-toggle
                    [control]="stateFormGroup.controls.stateFullDayIncrements"
                    [capitalizeLabel]="false"
                    [icon]="'today'"
                    [label]="data.sysText.employerHoursBanks_fullDayIncrements">
                  </app-slide-toggle>
                  <button
                    type="button"
                    class="button-reset info-button"
                    [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
                    [matTooltip]="data.sysText.employerHoursBanks_fullDayIncrementsStateInfo"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="right">
                    <mat-icon class="button-icon">info_outline</mat-icon>
                  </button>
                </div>
              }
            </div>
            <button
              type="button"
              mat-icon-button
              [attr.aria-label]="data.sysText.remove_ariaLabel"
              [disableRipple]="true"
              (click)="onBankRemoveStateName(stateIndex)">
              <mat-icon [ngClass]="{'accent': true, 'margin-bottom-17': !(isHandheld$ | async)}">close</mat-icon>
            </button>
          </div>
        }
      </div>
      <button
        #addStateButton
        type="button"
        (click)="onBankAddStateName()"
        mat-flat-button
        color="accent"
        class="button add-additional-button">
        {{data.sysText.employerHoursBanks_addStateName}}
      </button>
    </div>

    @if (data.isBank) {
      <div class="section-container">
        <div class="title-container">
          <h2 class="overline grey1 semibold section-title">{{ data.sysText.editEmployerHoursBanks_ruleSection }}</h2>
          <button
            type="button"
            class="button-reset info-button"
            [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
            [matTooltip]="data.sysText.employerHoursBanks_ruleInfo"
            [matTooltipShowDelay]="500"
            matTooltipPosition="before">
            <mat-icon class="button-icon">info_outline</mat-icon>
          </button>
        </div>
        <mat-divider class="section-header-underline"></mat-divider>
        <div>
          @for(ruleFormGroup of form.controls.entitlementRules.controls; track ruleFormGroup; let ruleIndex = $index){
            <div class="field-row-container">
              <div class="field-container">
                <div class="field-line">
                  <app-select-field
                    class="margin-right"
                    [showBlankOption]="true"
                    [group]="form"
                    [icon]="'assignment_turned_in'"
                    [control]="ruleFormGroup.controls.stateId"
                    [options]="data.stateSelectionList"
                    [label]="data.sysText.employerHoursBanks_state"
                    [shouldCapitalize]="false">
                  </app-select-field>
                  <app-select-field
                    [showBlankOption]="true"
                    [group]="form"
                    [hideIconSpace]="!(isHandheld$ | async)"
                    [control]="ruleFormGroup.controls.leaveReasonId"
                    [options]="data.leaveReasonSelectionList"
                    [label]="data.sysText.employerHoursBanks_leaveReason"
                    [shouldCapitalize]="false">
                  </app-select-field>
                </div>
                <div class="field-line">
                  <app-input-field
                    class="margin-right"
                    [inputType]="'number'"
                    [label]="data.sysText.employerHoursBanks_quantity"
                    [control]="ruleFormGroup.controls.quantity">
                  </app-input-field>
                  <app-select-field
                    [control]="ruleFormGroup.controls.quantityMeasure"
                    [label]="data.sysText.employerHoursBanks_quantityMeasure"
                    [options]="data.quantityMeasureList"
                    [hideIconSpace]="!(isHandheld$ | async)"
                    [shouldCapitalize]="false"
                    [shouldTitlecaseLabel]="false"
                    [info]="data.sysText.durationType_Info">
                  </app-select-field>
                </div>
                <div class="slide-container">
                  <app-slide-toggle
                    [control]="ruleFormGroup.controls.oneTimeEntitlement"
                    [capitalizeLabel]="false"
                    [icon]="'trending_flat'"
                    [label]="data.sysText.editEmployerHoursBanks_oneTimeEntitlement">
                  </app-slide-toggle>
                  <button
                    type="button"
                    class="button-reset info-button"
                    [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
                    [matTooltip]="data.sysText.editEmployerHoursBanks_oneTimeEntitlementInfo"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="right">
                    <mat-icon class="button-icon">info_outline</mat-icon>
                  </button>
                </div>
              </div>
              <button
                type="button"
                mat-icon-button
                [attr.aria-label]="data.sysText.remove_ariaLabel"
                [disableRipple]="true"
                (click)="onBankRemoveRule(ruleIndex)">
                <mat-icon [ngClass]="{'accent': true, 'margin-bottom-17': !(isHandheld$ | async)}">close</mat-icon>
              </button>
            </div>
          }
        </div>
        <button
          #addRuleButton
          type="button"
          (click)="onBankAddRule()"
          mat-flat-button
          color="accent"
          class="button add-additional-button">
          {{data.sysText.employerHoursBanks_addRule}}
        </button>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{data.sysText.cancel}}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{data.sysText.save}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

